import { Badge as MuiBadge, styled } from "@mui/material";
import { toolbarButtonName } from "../classes.js";
const Badge = styled(MuiBadge, {
  name: toolbarButtonName,
  slot: "Badge",
  overridesResolver: (_props, styles) => [styles.badge]
})(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: theme.spacing(4)
}));
export {
  Badge
};
//# sourceMappingURL=Badge.js.map
